import appConfig from 'appConfig';

import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { createEventHandler, getSettingsValues } from '@wix/tpa-settings';

import { Events, WixCodeMembersDummy } from './types';
import settingsParams from './settingsParams';

const createController: CreateControllerFn = async ({
  controllerConfig,
  appData,
  flowAPI,
}) => {
  const { setProps } = controllerConfig;

  const config = flowAPI.controllerConfig;
  const api = config.wixCodeApi;

  const member = await (
    (api as any).members as WixCodeMembersDummy | undefined
  )?.currentMember?.getMember();

  const avatar = member?.profile?.profilePhoto?.url;

  const navigation = {
    baseUrl: api.location.baseUrl,
    navigateTo: api?.location?.navigateTo,
    navigateToUrl: api?.location?.to,
  };

  const publicData = controllerConfig.config.publicData.COMPONENT || {};
  const handler = createEventHandler<Events>(publicData);
  const onHandlerEvent = handler.on.bind(this);
  const onHandlerReset = handler.onReset.bind(this);

  const initialLayoutOpen = publicData.initialVisualLayoutState === 'visible';

  const instanceToken =
    api?.site?.getAppToken && api.site.getAppToken(appConfig.appDefinitionId);

  const getSettings = (pd: any) => {
    const { currentLanguage, isEnabled, siteLanguages } =
      controllerConfig.wixCodeApi.window.multilingual;

    const currentLanguageSettings = getSettingsValues(pd, settingsParams, {
      t: flowAPI.translations.t,
      language: isEnabled ? currentLanguage : undefined,
    });

    const primaryLanguageSettings = isEnabled
      ? getSettingsValues(pd, settingsParams, {
          t: flowAPI.translations.t,
          language: siteLanguages.find(
            ({ isPrimaryLanguage }) => isPrimaryLanguage,
          )!.languageCode,
        })
      : currentLanguageSettings;

    const settings = {
      current: currentLanguageSettings,
      primary: primaryLanguageSettings,
    };

    return settings;
  };

  return {
    async pageReady() {
      setProps({
        onHandlerEvent,
        onHandlerReset,
        navigation,
        initialLayoutOpen,
        instanceToken,
        avatar,
        page: flowAPI.viewerScriptFlowAPI.siteAPI.currentPage,
        settings: getSettings(publicData),
        ecom: (api as any).ecom,
      });
    },
    updateConfig($w, c) {
      const pd = c.publicData.COMPONENT || {};
      handler.notify(pd);
      setProps({
        settings: getSettings(pd),
      });
    },
  };
};

export default createController;
